// extracted by mini-css-extract-plugin
export default {"dialog":"VerifyEmailDialog_dialog__uZrT1","formButton":"VerifyEmailDialog_formButton__kW8Sv"};